import { Box, Modal } from "@material-ui/core";
import React from "react";

const defaultStyle = {
	position: "absolute",
	top: "30%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	bgcolor: "white",
	border: "1px solid rgb( 0, 0, 0, 0.2 )",
	borderRadius: "5px",
	boxShadow: 24,
	p: 4
};

const scrollableStyle = {
	position: "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	bgcolor: "white",
	border: "1px solid rgb( 0, 0, 0, 0.2 )",
	borderRadius: "5px",
	boxShadow: 24,
	p: 4,
	maxHeight: "90vh",
	width: "90vw",
	maxWidth: "800px",
	overflowY: "auto"
};

export default function BasicModal({
	children,
	open,
	handleClose,
	scrollable = false,
	style
}) {
	const baseStyle = scrollable ? scrollableStyle : defaultStyle;
	const mergedStyle = style ? { ...baseStyle, ...style } : baseStyle;

	return (
		<div>
			<Modal open={open} onClose={handleClose}>
				<Box sx={mergedStyle}>{children}</Box>
			</Modal>
		</div>
	);
}
